import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "slice",
  initialState: {
    breakpoint: "",
  },
  reducers: {
    setBreakpoint: (state, action) => {
      state.breakpoint = action.payload;
    },
  },
});

export const { setBreakpoint } = slice.actions;
export default slice.reducer;
